import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { handlePutRequest } from "../../services/PutTemplate";
import * as Yup from "yup";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";
import ZDropdown from "../../components/zDropdown/ZDropdown";

const UpdateUserForm = ({ formData, onCloseModal, getAllUsers, companyId }) => {
  const [loading, setloading] = useState(false);
  const [loadingIcon, setloadingIcon] = useState("");

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("This field is required."),
    activeInactive: Yup.string().required("This field is required."),
    email: Yup.string().required("This field is required.").email(),
    userTypeId: Yup.string().required("This field is required."),
    gateId: Yup.string().when("userTypeId", {
      is: (val) => val === "5" || val === 5,
      then: Yup.string().required("This field is required."),
    }),
  });

  const statusOptions = [
    { label: "Active", value: "1" },
    { label: "Inactive", value: "0" },
  ];

  useEffect(() => {
    if (formData) {
      formik.setFieldValue("name", formData?.name);
      formik.setFieldValue("email", formData?.email);
      formik.setFieldValue(
        "activeInactive",
        formData?.activeInactive.toString()
      );
      formik.setFieldValue("userTypeId", formData?.userTypeId);
      if (formData?.userTypeId === 5) {
        formik.setFieldValue("gateId", formData?.gateId);
      }
    }
  }, [formData]); // eslint-disable-line

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      name: "",
      email: "",
      password: "",
      activeInactive: "",
      userTypeId: "",
      gateId: "",
    },
    onSubmit: async (data) => {
      try {
        setloading(true);
        setloadingIcon("pi pi-spin pi-spinner");
        data["activeInactive"] = parseInt(data["activeInactive"]);
        if (data.password === "") {
          data.password = null;
        }
        await handlePutRequest(data, "user/update/" + formData.userId);
        setloading(false);
        setloadingIcon("pi pi-save");
        getAllUsers();
        onCloseModal();
      } catch (error) {
        setloading(false);
        setloadingIcon("pi pi-save");
      }
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  return (
    <div className="card Card__Round">
      <div className="Form__Header">
        <h1> Update User </h1>
      </div>
      <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                placeholder="Enter Name"
                label="Name"
                keyName="name"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                required
                placeholder="Enter email"
                label="Email"
                keyName="email"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZbizInput
                type={"password"}
                placeholder="leave blank if you don't want to change"
                label="Password"
                keyName="password"
                {...props}
              />
            </div>
          </div>
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <ZDropdown
                {...props}
                label="Role"
                required
                valueOption="id"
                keyName="userTypeId"
                placeholder="Select Role"
                optionLabel="description"
                url="lov/userTypes"
              />
            </div>
          </div>
          {formik.values.userTypeId === 5 && (
            <div className="p-field p-col-12 p-md-6">
              <div className="p-field">
                <ZDropdown
                  {...props}
                  label="Gate"
                  required
                  valueOption="id"
                  keyName="gateId"
                  placeholder="Select Gate"
                  optionLabel="description"
                  url={`lov/gates/${companyId}`}
                />
              </div>
            </div>
          )}
          <div className="p-field p-col-12 p-md-6">
            <div className="p-field">
              <label
                htmlFor="activeInactive"
                className={classNames(
                  { "p-error": isFormFieldValid("activeInactive") },
                  "Label__Text"
                )}
              >
                Status<span className="Label__Required">*</span>
              </label>
              <Dropdown
                id="activeInactive"
                placeholder="Select Status"
                options={statusOptions}
                name="activeInactive"
                value={formik.values.activeInactive}
                onChange={formik.handleChange}
                className={classNames(
                  { "p-invalid": isFormFieldValid("activeInactive") },
                  "Dropdown__Round"
                )}
              />
              {getFormErrorMessage("activeInactive")}
            </div>
          </div>
        </div>

        <div className="Down__Btn">
          <Button
            disabled={loading}
            icon={loadingIcon || ""}
            iconPos="right"
            label={"Update"}
            className="Btn__Dark"
          />
        </div>
      </form>
    </div>
  );
};

export default UpdateUserForm;
